import { useCallback, useState } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { CallInsightAccordionType } from '../types';

type CallInsightPanelState = {
  defaultAccordion: CallInsightAccordionType | null;
  defaultHighlightedTaskId: string | null;
};
export const useCallInsightPanelState = ({ defaultAccordion, defaultHighlightedTaskId }: CallInsightPanelState) => {
  const [activeAccordion, setActiveAccordion] = useState<CallInsightAccordionType | null>(defaultAccordion);
  const [highlightedTaskId, setHighlightedTaskId] = useState<string | null>(defaultHighlightedTaskId);
  const [unsavedChangesConfig, setUnsavedChangesConfig] = useState<CallIntelTypes.UnsavedEditChangesConfig>({
    actionType: 'NO_ACTION',
    dontAskAgain: false,
    entity: '',
    hasUnsavedChanges: false,
  });

  const handleUnsavedChangesConfig = useCallback(
    (config: CallIntelTypes.UnsavedEditChangesConfig) =>
      setUnsavedChangesConfig({ ...unsavedChangesConfig, ...config }),
    [unsavedChangesConfig]
  );

  return {
    activeAccordion,
    highlightedTaskId,
    unsavedChangesConfig,
    setActiveAccordion,
    setHighlightedTaskId,
    setUnsavedChangesConfig: handleUnsavedChangesConfig,
  };
};
